// eslint-disable-next-line import/no-extraneous-dependencies
import 'simplebar/dist/simplebar.min.css';
import { makeStyles } from '@mui/styles';
import SimpleBar from 'simplebar-react';

interface ScrollableContainerProps {
  children: JSX.Element | JSX.Element[];
}

const useStyles = makeStyles(() => ({
  scrollbox: {
    display: 'flex',
    flexDirection: 'column',
    flex: '1 1 0',
    overflowY: 'auto',
    width: '100%',
    '& .simplebar-content': {
      height: '100%',
      display: 'flex',
    },
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    flex: '1 0 0',
    width: '100%',
  },
}));

export const ScrollableContainer = ({ children }: ScrollableContainerProps): JSX.Element => {
  const styles = useStyles();

  return (
    <SimpleBar className={styles.scrollbox}>
      <div className={styles.content}>{children}</div>
    </SimpleBar>
  );
};

export default ScrollableContainer;
